export const modalTypes = {
  documentInfo: 1,
  documentRetry: 2,
  signatureInfo:3,
  selfieSpecialInfo:4,
  signatureSuccess: 5,
  signatureRetry: 6,
  formSuccess: 7,
  formRetry: 8,
  failure: 9,
  successful: 10,
  cancelled:11,
  otpFailed: 12,
  documentFailed:13,
  loginSuccess: 14
};

const types = {
  SET_ERROR: 'SET_ERROR',
  UNSET_ERROR: 'UNSET_ERROR',
  STEP_FORWARD: 'STEP_FORWARD',
  STEP_TWO_FORWARD: 'STEP_TWO_FORWARD',
  STEP_BACKWARDS: 'STEP_BACKWARDS',
  SET_STEP: 'STEP_STEP',
  SET_OPERATION_DATA: 'SET_OPERATION_DATA',
  SET_USER_DATA: 'SET_USER_DATA',
  SET_CONFIRMATION_DATA: 'SET_CONFIRMATION_DATA',
  SET_CONTRACTS: 'SET_CONTRACTS',
  SET_MODAL: 'OPEN_MODAL',
  SET_PHOTO: 'SET_PHOTO',
  SET_CAMERA: 'SET_CAMERA',
  SET_LOADING: 'SET_LOADING',
};

export default types;
